export default __webpack_public_path__ + "media/PLATINUM PACKAGE.782028948f8f7c5b806bfec3098ba65e.mp4";